// @ts-nocheck
import { linkStyles } from "@store/Themes/common/mixins/link";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { css } from "styled-components";
/* Store Custom Code - End */

const link: Styleguide["link"] = {
    defaultProps: {
        color: null as any,
        hoverStyle: null as any,
        hoverMode: null as any,
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.semibold}; /* Store Custom Code */
            ${linkStyles("text.link", "text.linkHover", false, true)}
        `,
    },
};

export default link;
